/**
 * 여러 개의 프로미스를 받아서 모두 실행하고 결과를 반환하는 함수
 * Promise.allSettled와 비슷하지만 커스텀 포맷으로 결과를 반환
 * @param {Promise[]} promises - 실행할 프로미스 배열
 * @returns {Promise<Array<{success: boolean, value: any}>>} - 프로미스 실행 결과 배열
 */
export const promiseSettled = async (promises) => {
  try {
    const results = await Promise.allSettled(promises);
    
    return results.map(result => {
      if (result.status === 'fulfilled') {
        return {
          success: true,
          value: result.value
        };
      } else {
        return {
          success: false,
          reason: result.reason
        };
      }
    });
  } catch (error) {
    console.error('Promise settled error:', error);
    return [{
      success: false,
      reason: error
    }];
  }
}; 